import { render, staticRenderFns } from "./ReplicateMenus.vue?vue&type=template&id=bd0c032e&scoped=true"
import script from "./ReplicateMenus.vue?vue&type=script&lang=ts"
export * from "./ReplicateMenus.vue?vue&type=script&lang=ts"
import style0 from "./ReplicateMenus.vue?vue&type=style&index=0&id=bd0c032e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0c032e",
  null
  
)

export default component.exports